import { render, staticRenderFns } from "./collectCom.vue?vue&type=template&id=54f10364&scoped=true"
import script from "./collectCom.vue?vue&type=script&lang=js"
export * from "./collectCom.vue?vue&type=script&lang=js"
import style0 from "./collectCom.vue?vue&type=style&index=0&id=54f10364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f10364",
  null
  
)

export default component.exports